import { IConnectionState } from '../../interfaces';
import { inject, injectable } from 'inversify';
import {
    ISSEForKondorBlotterService,
    SSE_FOR_KONDOR_BLOTTER_SERVICE,
} from '../sse-for-kondor-blotter';
import {
    IStateOfKondorBlotterConnectionService,
} from './state-of-kondor-blotter-connection.interface';
import { now } from '../../helpers/time';
import { Observable, Subject } from 'rxjs';

@injectable()
export class StateOfKondorBlotterConnectionService implements IStateOfKondorBlotterConnectionService {

    @inject(SSE_FOR_KONDOR_BLOTTER_SERVICE) private readonly sseSrv: ISSEForKondorBlotterService;

    private state$: Subject<IConnectionState>;

    asObservable(): Observable<IConnectionState> {
        if (!Boolean(this.state$)) {
            this.state$ = new Subject();

            this.sseSrv.addEventListener('CONNECTION_BROKEN', () => {
                this.state$.next({
                    state: 'disconnected',
                    timestamp: now(),
                });
            });

            this.sseSrv.addEventListener('HEARTBEAT', () => {
                this.state$.next({
                    state: 'connected',
                    timestamp: now(),
                });
            });

            this.sseSrv.addEventListener('BLOTTER_ROW', () => {
                this.state$.next({
                    state: 'connected',
                    timestamp: now(),
                });
            });
        }

        return this.state$.asObservable();
    }
}
